import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconCheckCircle = ({ sx, ...props }: SvgIconProps) => (
    <ThemedFillSvgIcon sx={{ color: "green.600", fill: "white", ...sx }} {...props}>
        <svg viewBox="0 0 20 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
                fill="inherit"
            />
            <path d="M15 7L8.72597 14L5 11.375" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </ThemedFillSvgIcon>
);
